import React from 'react';
import StandardPageLayout from '../components/StandardPageLayout';
import CareersStarfield from '../components/CareersStarfield';
import { Card, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Briefcase, Heart, Gift, Users, MapPin, Clock } from 'lucide-react';

const Careers = () => {
  return (
    <StandardPageLayout
      heroTitle="Join Our Team"
      heroDescription="Help us build the future of elegant intelligence. We're looking for innovators, creators, and dreamers."
      heroBackgroundClass="bg-[#eceee8]"
      heroBackgroundNode={<CareersStarfield />}
      
      section2Title="Upcoming Positions"
      section2Description="Explore opportunities across engineering, design, product, sales, marketing, and operations."
      section2Content={
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            { title: 'Forward Deployed Engineer', dept: 'Engineering', location: 'Remote', type: 'Full-time' },
            { title: 'Enterprise Account Executive', dept: 'Sales', location: 'Remote', type: 'Full-time' },
            { title: 'Partnerships Strategy & Enablement Lead', dept: 'Partnerships', location: 'Remote', type: 'Full-time' },
            { title: 'Deployment Strategist', dept: 'Customer Deployment', location: 'Remote', type: 'Full-time' },
            { title: 'Cloud Security Engineer', dept: 'Security', location: 'Remote', type: 'Full-time' },
            { title: 'Legal Counsel', dept: 'Legal', location: 'Remote', type: 'Full-time' },
          ].map((job, idx) => (
            <Card key={idx} className="bg-[#E8EDE7] border-[#D4DDD1]/50 hover:bg-white hover:border-[#D4DDD1] hover:-translate-y-1 transition-all duration-300 cursor-pointer">
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <CardTitle className="text-xl font-medium text-black/90 mb-2">
                      {job.title}
                    </CardTitle>
                    <div className="flex flex-wrap gap-2 text-sm text-black/60">
                      <span className="flex items-center gap-1">
                        <Briefcase className="h-4 w-4" /> {job.dept}
                      </span>
                      <span className="flex items-center gap-1">
                        <MapPin className="h-4 w-4" /> {job.location}
                      </span>
                      <span className="flex items-center gap-1">
                        <Clock className="h-4 w-4" /> {job.type}
                      </span>
                    </div>
                  </div>
                </div>
              </CardHeader>
            </Card>
          ))}
        </div>
      }
      
      section3Title="Our Culture & Benefits"
      section3Description="We invest in our people with comprehensive benefits that support your success and well-being."
      section3Content={
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { icon: Gift, title: 'Competitive Salary', description: 'Industry-leading compensation packages' },
            { icon: Heart, title: 'Health Insurance', description: 'Comprehensive coverage for you and your family' },
            { icon: Users, title: 'Performance Bonuses', description: 'Rewarding excellence and results' },
            { icon: Clock, title: 'Paid Time Off', description: 'Generous PTO to recharge and refresh' },
            { icon: Briefcase, title: 'Learning Budget', description: '$5,000 annual professional development budget' },
            { icon: Gift, title: 'Wellness Programs', description: 'Physical and mental health support' },
          ].map((item, idx) => (
            <Card key={idx} className="bg-white border-[#D4DDD1]/40 hover:bg-[#F5F7F5] transition-all duration-300">
              <CardHeader>
                <div className="w-12 h-12 rounded-xl bg-[#E8A0B8]/10 flex items-center justify-center mb-4">
                  <item.icon className="h-6 w-6 text-[#E8A0B8]" />
                </div>
                <CardTitle className="text-lg font-medium text-black/90 mb-2">
                  {item.title}
                </CardTitle>
                <CardDescription className="text-black/70">
                  {item.description}
                </CardDescription>
              </CardHeader>
            </Card>
          ))}
        </div>
      }
      
      ctaTitle="Ready to join our team?"
      ctaDescription="We're building more than software — we're creating a place where great people do their best work."
      ctaButtonText="Apply now"
      ctaButtonHref="/careers/applynow"
      ctaButtonNewTab={true}
    />
  );
};

export default Careers;
